import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { helpCenterSettingsAgentStudioConversationReviewRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsAgentStudioConversationReviewRoute.tsx';
import { resources } from '@atlassian/csm-conversation-review/resources';

import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	LazyAgentStudioConversationReviewPage,
	AgentStudioConversationReview,
	csmAgentConversationReviewPageEntryPoint,
} from './ui/agent-studio/index.tsx';
import { agentStudioNavigation } from './common/constants.tsx';

const getConversationReviewResources = () => resources.conversationReview;

export const helpCenterSettingsAgentStudioConversationReviewRouteEntry = createEntry(
	helpCenterSettingsAgentStudioConversationReviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.agent-studio.conversation-review',
		entryPoint() {
			if (!fg('enable_support_center_agent_studio_page')) {
				return undefined;
			}
			return csmAgentConversationReviewPageEntryPoint;
		},
		component: componentWithFG(
			'enable_support_center_agent_studio_page',
			AgentStudioConversationReview,
			ErrorPagesNotFound,
		),
		layout: serviceProjectLayout,
		navigation: agentStudioNavigation,
		resources: [...getServiceDeskSettingsResources(), ...getConversationReviewResources()],
		forPaint: [LazyAtlassianNavigation, LazyAgentStudioConversationReviewPage],
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	}),
);
